import React, { useRef, useState } from 'react'
import { getCdnAssetUrl } from 'shared/helpers/assets'
import { ReactComponent as PlayIcon } from 'shared/assets/icons/resident-play-big.svg'
import { ReactComponent as PlayIconSmall } from 'shared/assets/icons/resident-play-small.svg'

function Video({ className = '', src, poster }) {
  const [playing, setPlaying] = useState(false)
  const videoRef = useRef()
  const [posterLoaded, setPosterLoaded] = useState()
  function play() {
    setPlaying(true)
    videoRef.current.play()
  }

  return (
    <div className={className}>
      {!playing && (
        <div className="h-full w-full flex items-center justify-center" onClick={play}>
          {posterLoaded && (
            <button type="button" className="absolute">
              <em className="hidden lg:inline-block">
                <PlayIcon />
              </em>
              <em className="lg:hidden">
                {' '}
                <PlayIconSmall />
              </em>
            </button>
          )}
          <img
            src={getCdnAssetUrl(poster)}
            onLoad={() => {
              setPosterLoaded(true)
            }}
            className="max-h-full object-contain"
            alt="welcome_video"
          />
        </div>
      )}
      <video
        onLoadStart={(e) => {
          e.target.volume = 0.2
        }}
        ref={videoRef}
        className={`max-h-full object-contain ${!playing ? 'hidden' : ''}`}
        controls
        preload
        src={getCdnAssetUrl(src)}
      />
    </div>
  )
}

export default Video
